"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = {
    SRC_LOAD_ERROR: 'SRC_LOAD_ERROR',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/errors.js
// module id = 1518
// module chunks = 0 1 2 3